export default __webpack_public_path__ + "static/media/placeholder_store03-es-web.1d0e2b2e.png";